import { Inject, Injectable } from '@angular/core';
import {
  HttpClient,
} from '@angular/common/http';
import { AppService } from './app.service';

@Injectable({ providedIn: 'root' })
export class ExemptionSearchService extends AppService {
  constructor(
    public http: HttpClient,
    @Inject('environment') environment: any
  ) {
    super(http, environment);
  }
  ///
  searchExemption(
    pageIndex: number,
    recordsPerPage: number,
    searchQuery?: string
  ) {
    var endpoint = `ExemptionSearch?Page=${pageIndex}&RecordsPerPage=${recordsPerPage}`;
    if (typeof searchQuery !== 'undefined') {
      endpoint = endpoint + `${searchQuery}`;
    }
    return this.http.get<any>(
      this.getEndpoint(endpoint),
      this.gethttpOptions()
    );
  }
}
